import { useState } from 'react';

import { TaskResponse } from '../../client';
import { useEquationMiniGame } from '../../hooks';

import { TaskCard } from './TaskCard';

interface TaskCardEquationsProps {
  task: TaskResponse;
  onTaskStarted: (task: TaskResponse) => Promise<void>;
  onTaskProgress: (task: TaskResponse, progress: number) => void;
  onTaskCompleted: (task: TaskResponse) => Promise<void>;
}

export function TaskCardEquationSolver({
  task,
  onTaskStarted,
  onTaskProgress,
  onTaskCompleted,
}: TaskCardEquationsProps) {
  const { equation, provideAnswer, resetError, errorMessage, gameWon } = useEquationMiniGame(
    task,
    onTaskStarted,
    onTaskProgress,
    onTaskCompleted,
  );

  return (
    <TaskCard task={task}>
      <p className="text-center text-2xl mb-4">
        <b>{equation}</b> = ?
      </p>

      <ResultInput onChange={resetError} onSubmit={provideAnswer} disabled={gameWon} errorMessage={errorMessage} />
    </TaskCard>
  );
}

interface ResultFormProps {
  onChange: (value: string) => void;
  onSubmit: (value: string) => void;
  disabled: boolean;
  errorMessage?: string;
}

function ResultInput({ onChange, onSubmit, disabled, errorMessage }: ResultFormProps) {
  const [value, setValue] = useState<string>('');
  const isInvalid = !!errorMessage;

  return (
    <div>
      <label className="block text-sm font-medium mb-1">Your answer:</label>
      <div className="relative">
        <input
          className={`w-full pr-[4.5rem] mb-2 px-3 py-2 rounded-md border bg-bg-input transition-colors focus:outline-none focus:ring-2 focus:ring-action-primary ${
            isInvalid ? 'border-feedback-error focus:ring-feedback-error' : 'border-border-default'
          }`}
          autoFocus
          value={value}
          inputMode="decimal"
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onSubmit(value);
            }
          }}
        />
        <div className="absolute right-1 top-1">
          <button
            className="px-3 py-1.5 text-sm font-medium text-white bg-action-primary hover:bg-action-primary-hover rounded-md transition-colors disabled:opacity-50"
            onClick={() => onSubmit(value)}
            disabled={disabled}
          >
            Check
          </button>
        </div>
      </div>
      {isInvalid ? (
        <p className="text-sm text-feedback-error mt-1">{errorMessage}</p>
      ) : (
        <p className="text-sm text-transparent mt-1">&nbsp;</p>
      )}
    </div>
  );
}
